import axiosInstance from './';
import Storage from '../helpers/storage';

export default class {
  constructor() {
    this.instance = axiosInstance();
  }

  getAll = () =>
    this.instance({
      url: `/variations?merchantId=${Storage.getLocalStorageMerchant().idUnity}`,
      method: 'GET',
    });

  post = data =>
    this.instance({
      url: '/variations',
      method: 'POST',
      data,
    });

  put = data =>
    this.instance({
      url: `/variations/${data.id}`,
      method: 'PUT',
      data,
    });

  delete = id =>
    this.instance({
      url: `/variations/${id}`,
      method: 'DELETE',
      data: {},
    });
}



// WEBPACK FOOTER //
// ./src/services/Variations.js